export default function (lang) {
  return require('./' + lang + '/default.json')
}
